import React from 'react'
import '../App.css'
import Footer from '../Footer'
import MortgageCalculator from './MortgageCalculator'

function Calculator() {
  return (
    <>
        <MortgageCalculator/>
        <Footer/>
    </>
  )
}

export default Calculator